module.exports = {
      id: "video-play-usage",
      viewBox: "0 0 58.316 58.344",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#video-play",
      toString: function () {
        return this.url;
      }
    }